<template>
    <div class="container">
        <div class="row d-flex justify-content-end col-md-2">
            <b-input-group class="mb-3" size="sm">
                <b-form-input
                    v-model="filtroContrato"
                    placeholder="Buscar por contrato"
                    debounce="100"
                    class="form-control"
                ></b-form-input>
            </b-input-group>
        </div>
        <div class="row col-md-12 justify-content-center " v-if="listContratos != 0">
            <b-table
                :items="listContratos"
                :fields="fields"
                hover
                bordered
                responsive
                sticky-header="500px"
                small
                class="tblEstandar"
                head-variant="custom-blue"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filtroContrato"
                :filter-function="filtrarPorContrato"
                @row-clicked="(item) => tipoModificacion(item.id)"
            >
                <template #cell(nro_contrato)="data">
                    <div class="text-right">{{ data.item.nro_contrato }}</div>
                </template>
                <template #cell(identificacion)="data">
                    <div class="text-left">{{ showArrendador(data.item.identificacion) }}</div>
                </template>
                <template #cell(tipo_contrato)="data">
                    <div class="text-left">{{ showTipoContrato(data.item.tipo_contrato) }}</div>
                </template>
                <template #cell(valor_contrato)="data">
                    <div class="text-right">{{ formatNumber(data.item.valor_contrato) }}</div>
                </template>
            </b-table>
            <div class="row col-md-12">
                <div class="col-md-10 d-flex justify-content-center">
                    <b-pagination
                    v-model="currentPage"
                    :total-rows="listContratos.length"
                    :per-page="perPage"
                    align="center"
                    size="md"
                    class="custom-pagination"
                    ></b-pagination>
                </div>
                <div class="col-md-2 d-flex justify-content-end">
                    <label class="mr-2 mb-0">Filas por página:</label>
                    <b-form-select
                    v-model="perPage"
                    :options="[5, 10, 20, 50, 100, 500]"
                    size="sm"
                    style="width: 80px;"
                    ></b-form-select>
                </div>
            </div>
            <!-- <md-table md-card md-fixed-header v-model="listContratos">
                <md-table-row slot="md-table-row" slot-scope="{ item }" @click="tipoModificacion(item.id)">
                    <md-table-cell :md-label="labels.nroContrato" class="border">{{ item.nro_contrato }}</md-table-cell>
                    <md-table-cell :md-label="labels.arrendador" class="border text-left" >{{ showArrendador(item.identificacion) }}</md-table-cell>
                    <md-table-cell :md-label="labels.tipoContrato" class="border text-left">{{ showTipoContrato(item.tipo_contrato) }}</md-table-cell>
                    <md-table-cell :md-label="labels.valorContrato" class="border text-right">{{ Intl.NumberFormat('es-CO',{ maximumFractionDigits: 3, minimumFractionDigits: 0}).format(item.valor_contrato) }}</md-table-cell>
                    <md-table-cell :md-label="labels.fechaInicial" class="border text-left">{{ item.fecha_inicial }}</md-table-cell>
                    <md-table-cell :md-label="labels.fechaFinal" class="border text-left">{{ item.fecha_final }}</md-table-cell>
                </md-table-row>
            </md-table> -->
        </div>
        <div class="row col-md-12 justify-content-center mt-3" v-else>
            <h5>{{ labels.noRow }}</h5>
        </div>
        <!-- <Detalle :modalDetalle="showDetalleContrato" :infoContrat="detailContrato" @cierraModal="closeModal"></Detalle> -->
        <ModificacionAutomatica :modalModAutomatica="showModAutom" :infoContrato="detalleContrato" @cierraModal="closeModal"></ModificacionAutomatica>
        <ModificacionManual :modalModManual="showModManual" :infoContrato="detalleContrato" @cierraModal="closeModal"></ModificacionManual>
    </div>
</template>

<script>
import Contrato from '../../services/Contrato';
import Tercero from '../../services/Tercero';
import TipoContrato from '../../services/TipoContrato'
// import Detalle from './Detalle.vue';
import ModificacionAutomatica from './ModificacionAutomatica.vue';
import ModificacionManual from './ModificacionManual.vue';

export default {
    name: 'Consultar',
    props: ['tipoModify'],
    components : {
        ModificacionAutomatica,
        ModificacionManual
    },
    data: () => ({
        listContratos : [],
        listTipoContrato : [],
        listTercero : [],
        listTipoAct : [],
        listActivo : [],
        detalleContrato : [],
        // showCreaContrato : false,
        // showDetalleContrato : false,
        // detailContrato : []
        showModAutom : false,
        showModManual : false,
        perPage: 500,
        currentPage: 1,
        filtroContrato: '',
        fields: [
            { key: 'nro_contrato', label: 'Contrato', sortable: false },
            { key: 'identificacion', label: 'Arrendador', sortable: false },
            { key: 'tipo_contrato', label: 'Tipo contrato', sortable: false },
            { key: 'valor_contrato', label: 'Valor contrato', sortable: false },
            { key: 'fecha_inicial', label: 'Fecha inicial', sortable: false },
            { key: 'fecha_final', label: 'Fecha final', sortable: false }
        ],
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    noRow : "No hay registros",
                    nroContrato : "Nro",
                    arrendador : 'Arrendador....................................................',
                    fechaActivacion : 'F Activación',
                    fechaInicial : 'Fecha Inicial',
                    fechaFinal : 'Fecha Final..',
                    tipoContrato : 'Tp Contrato',
                    valorContrato : 'Vr Contrato',
                    estado : 'Estato'
                }
            }else{
                return {
                    noRow : "There are not records",
                    nroContrato : "Contract number",
                    arrendador : 'Lessor',
                    fechaActivacion : 'Activation date',
                    fechaInicial : 'Strating date',
                    fechaFinal : 'End date',
                    tipoContrato : 'Contract type',
                    valorContrato : 'Contract value',
                    estado : 'State'
                }
            }
        },
        filteredRows() {
            // Devuelve cuántos registros hay luego de aplicar el filtro
            return this.listContratos.filter(item =>
                item.nro_contrato.toString().includes(this.filtroContrato)
            ).length
        }
    },
    methods:{
        filtrarPorContrato(item, filtro) {
            if (!filtro) return true
            const texto = filtro.toString().toLowerCase()
            return item.nro_contrato.toString().toLowerCase().includes(texto)
        },
        formatNumber(value) {
            return new Intl.NumberFormat('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 3 }).format(value);
        },
        tipoModificacion(id){
            if(this.tipoModify == 'Manual'){
                this.showModManual = true
                this.showModAutom = false
            }else{
                this.showModAutom = true
                this.showModManual = false
            }

            Contrato.getContratoById(id)
            .then((res) => {
                // console.log(res.data.contractById[0]);
                this.detalleContrato = res.data.contractById[0]
            })
            .catch((err) => console.log(err))
        },
	showArrendador(identify){
		if	(identify == null || identify == undefined) {
			return identify
		}
		let nameTercero = this.listTercero.find((tercer) => tercer.identificacion === identify)

		if	(nameTercero == undefined) {
			return "Tercero "+identify
		}
		return nameTercero.nombre
	},
	showTipoContrato(tipContrato){
		if	(tipContrato == null || tipContrato == undefined) {
			return tipContrato
		}
		let tipoContrato = this.listTipoContrato.find((tipoContact) => tipoContact.tipo_contrato === tipContrato)
		if	(tipoContrato == undefined) {
			return "Tipo Contrato  "+tipoContrato
		}
		return tipoContrato.descripcion
	},
        closeModal(val){
            // this.showCreaContrato = val
            // this.showDetalleContrato = val
            this.showModAutom = val
            this.showModManual = val
        }
    },
    mounted(){
        Contrato.getAllContratos()
        .then((res) => {
            this.listContratos = res.data.listContratos
            this.listContratos = this.listContratos.filter((c) => c.estado == 'Inicial') // Muestra solo los que son estado Inicial
        })
        .catch((err) => console.log(err))

        Tercero.getAllTercero()
        .then((res) => {
            this.listTercero = res.data.listTercero
        })
        .catch((err) => console.log(err))

        TipoContrato.getAllTipoContrato()
        .then((res) => {
            this.listTipoContrato = res.data.listTipoContrato
        })
        .catch((err) => console.log(err))
    }
}
</script>
<style lang="css">
	.md-table-cell-container {
		padding: 15px !important;
		max-width: 500px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>
